<template>
  <div>
    <div class="suggestions" v-if="!allTimesUnavailable">
      <div id="suggestions-requested-unavailable-container">

        <div v-if="timeRequested==null" id="suggestions-requested-unavailable">The requested timeslot is not available.</div>
      </div>
      <div id="suggestions-label">
        Select available timeslot:
      </div>
      <div id="suggestions-times">
        <suggested-time
          label="Nearest Time Before"
          v-on:timeSelected="timeSelected"
          v-if="timeRequested==null && timePrior!=null"
          :time="timePrior">
        </suggested-time>
        <suggested-time
          label="Requested time"
          v-on:timeSelected="timeSelected"
          v-if="timeRequested!=null"
          :time="timeRequested">
        </suggested-time>
        <suggested-time
          label="Nearest Time After"
          v-on:timeSelected="timeSelected"
          v-if="timeRequested==null && timeNext!=null"
          :time="timeNext">
        </suggested-time>
      </div>
    </div>
    <div class="suggestions all-unavailable" v-if="allTimesUnavailable">
      No more timeslots are available for this day. Please try another day.
    </div>
  </div>
</template>

<script>

import suggestedTime from '@comp/suggestedTime'

export default {
  name: "suggestedTimes",
  components: {
    suggestedTime
  },
  props: [ 'time' ],
  data() {
    return {

    }
  },
  computed: {
    allTimesUnavailable() {
      return ( this.timeRequested == null && this.timePrior == null && this.timeNext == null )
    },
    requestedTimeUnavailable() {
      return ( this.timeRequested == null && ( this.timePrior != null || this.timeNext != null ) )
    },
    timeRequested() {
      return this.$store.state.availability.suggestedTimes.requested
    },
    timePrior() {
      return this.$store.state.availability.suggestedTimes.prior
    },
    timeNext() {
      return this.$store.state.availability.suggestedTimes.next
    },
  },
  methods: {
    timeSelected( val ) {
      this.$emit( 'timeSelected', val )
    }
  }
}

</script>

<style scoped lang="scss">

.suggestions {
  margin-top: 20px;
  display: inline-block;
  margin-left: auto;
  margin-right: auto;
  min-height: 80px;
}

#suggestions-times {
  display: inline-block;
}

#suggestions-label {
  font-weight: bold;
}

.all-unavailable {
  font-weight: bold;
  text-align: center;
  color: #a71313;
  font-size: 125%;
  padding: 12px;
  border-radius: 5px;
  min-height: auto;
  border: 1px solid #a71313;
}

#suggestions-requested-unavailable-container {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 8px;
}

#suggestions-requested-unavailable {
  width: 75%;
  text-align: center;
  padding: 10px;
  border: 2px solid red;
  color: red;
  font-weight: bold;
  border-radius: 3px;
}

</style>